import {
  VIEW_DETAILS_FORM,
  VIEW_CONDITION_SCREENING,
  VIEW_PROGRAMS,
  VIEW_TERMS,
  VIEW_SWITCH_PROVIDER,
  VIEW_LAB_RESULTS,
  VIEW_SHIPPING_DETAILS,
  VIEW_DOWNLOAD_APP,
  VIEW_CONFIRM_DETAILS,
  VIEW_ERROR,
  VIEW_LABS_OUTREACH,
  VIEW_LABS_PENDING,
} from '@/consts/events';
import type { WregStep } from '@/components/webreg/wregSteps';

export const WREG_VIEW: Partial<Record<WregStep, string>> = {
  intake: VIEW_DETAILS_FORM,
  screener: VIEW_CONDITION_SCREENING,
  tracks: VIEW_PROGRAMS,
  agreement: VIEW_TERMS,
  switch: VIEW_SWITCH_PROVIDER,
  labs: VIEW_LAB_RESULTS,
  monitor: VIEW_SHIPPING_DETAILS,
  allset: VIEW_DOWNLOAD_APP,
  'x-mismatch': VIEW_CONFIRM_DETAILS,
  'x-error': VIEW_ERROR,
  'x-outreach': VIEW_LABS_OUTREACH,
  'x-labspending': VIEW_LABS_PENDING,
};
